export const Sparkle = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0c0 6.627-5.373 12-12 12 6.627 0 12 5.373 12 12 0-6.627 5.373-12 12-12-6.627 0-12-5.373-12-12z" />
  </svg>
);

const SectionLabel = ({ children, className = '', align = 'center' }) => (
  <div
    className={`flex items-center gap-2 text-[#FF8000] ${
      align === 'center' ? 'justify-center' : 'justify-start'
    } ${className}`}
  >
    <Sparkle className="w-[13px] h-[13px] md:w-[14px] md:h-[14px] shrink-0" />
    <span className="text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.18em] leading-none">
      {children}
    </span>
  </div>
);

export default SectionLabel;
